import axios from 'axios';

const state = {
    
};

const getters = {
    
};

const actions = {
    async signOntoWcea(state) {// get user Appointments 
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getSignOntoWceaUrl;
        const userId = state.rootState.user.userId;
        const header = {Authorization: `Bearer ${authorizationToken}`}; 
        let response = await axios.post(url, {id : userId}, { headers: header});// make api call
        return response.data;        
    },
    async getWceaCertificates(state, data) {// get user Appointments 
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getWceaCertificatesUrl;
        data.id = state.rootState.user.userId;
        const header = {Authorization: `Bearer ${authorizationToken}`}; 
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;        
    },
    async updateDoctorCpdPoints(state, data) {// get user Appointments 
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.updateDoctorCpdPointsUrl;
        data.id = state.rootState.user.userId;
        const header = {Authorization: `Bearer ${authorizationToken}`}; 
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;        
    }

};

const mutations = {
    
};  

export default {
    state,
    getters,
    actions,
    mutations
}